<!----
    Author: hjlee
    Description:
        언어 선택
---->
<template>
  <b-form-select v-model="selected" :class="{'locale-selector': true, 'hidden': !getLocales() || getLocales().length < 2}" :options="getLocales()" @change="setLocale" />
</template>

<script>
export default {
  data: function() {
    return {
      selected: ''
    }
  },
  watch: {
    '$store.state.locale': function(newVal) {
      this.selected = newVal
    }
  },
  mounted: function() {
    this.selected = localStorage.locale
    if (!this.$store.state.init_locale) {
      this.$store.commit('INIT_LOCALE')
      let locale = this.selected
      if (!locale) {
        locale = navigator.language || navigator.userLanguage
      }
      this.setLocale(locale)
    }
    this.$eventHub.$on('setLocale', this.onSetLocale)
  },
  beforeDestroy: function() {
    this.$eventHub.$off('setLocale', this.onSetLocale)
  },
  methods: {
    onSetLocale(locale) {
      this.setLocale(locale)
      this.selected = locale
      this.$forceUpdate()
    },
    setLocale(locale) {
      this.$i18n.locale = locale
    },
    getLocales() {
      const locales = window.copyObject(this.$store.state.locales)
      for (let i = 0; i < locales.length; i++) {
        if (locales[i].value !== this.$store.state.locale) {
          locales[i].text +=
            '<small> - ' + this.$t('locale.nm.' + locales[i].value) + '</small>'
        }
      }
      return locales
    }
  }
}
</script>

<style scoped>
.hidden {
  display: none;
}
</style>
